import {isRTL} from '../../../../Localization';

const en = {
    bi_icon_tooltip: 'Analysis Reports (BI)'
};

const he = {
    bi_icon_tooltip: 'דו"חות ניתוח'
};

export const texts = isRTL() ? he : en;
